<template>
  <div
    v-if="request.requestType === 'TRS'"
    class="mt-3"
  >
    <div>
      <span>{{ $t('trsExtrasView.ykGtrlmlidir') }} </span>
      <span class="text-dark">
        {{ requestExtras.pickupCountry }}, {{ requestExtras.pickupCity }}
        <span v-if="requestExtras.pickupAddress">({{ requestExtras.pickupAddress }}) </span>
      </span>
    </div>

    <div>
      <span>{{ $t('trsExtrasView.haraAtdrlmaldr') }} </span>
      <span class="text-dark">
        {{ requestExtras.dropOffCountry }}, {{ requestExtras.dropOffCity }}
        <span v-if="requestExtras.dropOffAddress">({{ requestExtras.dropOffAddress }}) </span>
      </span>
    </div>

    <div>
      <span>{{ $t('trsExtrasView.yknXacaTarix') }} </span>
      <span class="text-dark">
        {{ requestExtras.offerDeadline }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TRSExtrasView',
  props: {
    request: {},
    requestExtras: {}
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>